import { TRACKING_BEHAVIOR, useExperimentation } from '~/app/features/Gallery/hooks/useExperimentation'
import { experimentVariation, PRODUCT_COLLECTIONS_EXPERIMENT_NAME } from 'shared/experiments/constants'

export const useShowProductCollections = (): boolean => {
  const isExperimentActive = useExperimentation()

  return (
    isExperimentActive(experimentVariation[PRODUCT_COLLECTIONS_EXPERIMENT_NAME].Enabled1, TRACKING_BEHAVIOR.Suppress) ||
    isExperimentActive(experimentVariation[PRODUCT_COLLECTIONS_EXPERIMENT_NAME].Enabled2, TRACKING_BEHAVIOR.Suppress)
  )
}
